import {
	defaultLocale,
	isLocale,
	type Locale,
	LOCALE_STORAGE_KEY,
	locales,
} from "./config";

const localePrefix = new RegExp(`^/(${locales.join("|")})(/|$)`);

export function parseLocaleFromPathname(pathname: string | null): Locale {
	if (!pathname || pathname === "/") return defaultLocale;
	const m = pathname.match(localePrefix);
	if (m && isLocale(m[1])) return m[1];
	return defaultLocale;
}

/** Strip /en prefix from pathname for same-page locale switches */
export function pathWithoutLocale(pathname: string): string {
	const stripped = pathname.replace(localePrefix, "/");
	if (stripped === "") return "/";
	return stripped.startsWith("/") ? stripped : `/${stripped}`;
}

/**
 * Prefix a site path with locale. Idempotent if path already has a locale prefix.
 * @param path e.g. "/login" or "/dashboard/"
 */
export function withLocale(locale: Locale, path: string): string {
	if (localePrefix.test(path)) return path;
	const p = path.startsWith("/") ? path : `/${path}`;
	if (p === "/") return `/${locale}/`;
	return `/${locale}${p}`;
}

export function pickBrowserLocale(): Locale {
	if (typeof navigator === "undefined") return defaultLocale;
	const wanted = navigator.languages?.length
		? navigator.languages
		: [navigator.language];
	for (const w of wanted) {
		const code = w.slice(0, 2).toLowerCase();
		if (isLocale(code)) return code;
	}
	return defaultLocale;
}

export function resolveLocaleFromStorage(): Locale | "system" {
	if (typeof window === "undefined") return "system";
	const raw = window.localStorage.getItem(LOCALE_STORAGE_KEY);
	if (raw === "system" || raw === null) return "system";
	if (isLocale(raw)) return raw;
	return "system";
}

